import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-block-item',
	templateUrl: './block-item.component.html',
	styleUrls: ['./block-item.component.scss'],
})
export class BlockItemComponent implements OnInit {
	@Input() text;

	@Output() stepChange = new EventEmitter();

	public hasUnderline;

	constructor(public router: Router) { }

	ngOnInit() {
		const keys = Object.keys(this.text.style);
		this.hasUnderline = keys.indexOf('text-decoration') !== -1;
	}

	handleClick(event) {
		if (this.text.data.internal) {
			event.preventDefault();
			const urlParts = this.text.data.url.split('/');
			if (urlParts[1] === 'features') {
				this.stepChange.emit({ step: urlParts.length - 1, path: this.text.data.url });
			} else {
				this.router.navigate([this.text.data.url]).then();
			}
		}
	}
}
